import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react'
import classNames from 'classnames'
import PubSub from 'pubsub-js'
import { logger } from 'lib/slardar-utils'
import Router from 'next/router'

import { useResponsive } from 'Components/hooks/use-responsive'
import { getHeaderHeight } from 'Components/hooks/use-header-height'
import useSideNavStatus from 'Components/hooks/use-side-nav-status'
import styles from './index.module.scss'
import Link from 'next/link'
import { IConfig } from 'New/side-nav/config'
import { GlobalStoreContext } from 'Components/store'
import { sendTeaCommEvent } from 'lib/tea-analyze'

type UsedCarLinkModalProps = {
  linkTaget?: '_blank' | '_self'
}

export default function UsedCarLinkModal({ linkTaget }: UsedCarLinkModalProps) {
  const [show, setShow] = useState(false)
  const navStatus = useSideNavStatus()
  const { state: globalStore } = useContext(GlobalStoreContext)
  const { userData } = globalStore
  const responsive = useResponsive()

  const [wrapTop, setWrapTop] = useState(0)

  const showHandler = useCallback((type, value) => {
    setShow(value)
    try {
      const navItemDOM = document.querySelector(
        `#sideItemWrap_${'usedcar'}`
      ) as HTMLElement
      const rect = navItemDOM?.getBoundingClientRect?.()
      setWrapTop(rect?.top - getHeaderHeight())
    } catch (err) {
      logger.warn(
        `[side item height] Error get side item height, err: ${
          (err as any)?.message
        }`
      )
    }
  }, [])
  useEffect(() => {
    const showToken = PubSub.subscribe('HOVER_USEDCAR', showHandler)
    return () => {
      PubSub.unsubscribe(showToken)
    }
  }, [])

  const getClassName: string = useMemo(() => {
    switch (navStatus) {
      case 'on':
      case 'fixed':
        return 'tw-left-160'
      case 'off':
        return 'tw-left-82 xl:tw-left-92'
      case 'md-off':
        return 'tw-left-82 lg:tw-left-160'
      case 'lg-off':
        return 'tw-left-82 xl:tw-left-160'
    }
    return 'tw-left-82 lg:tw-left-160'
  }, [navStatus])

  const [url, setUrl] = useState('')

  const routeChangeComplete = useCallback((url: string) => {
    if (url === '') {
      setUrl('/')
      return
    }
    console.log('test-url', url)
    setUrl(url)
  }, [])

  useEffect(() => {
    setUrl(window?.location?.pathname || '/')
    Router.events.on('routeChangeComplete', routeChangeComplete)
    return () => {
      Router.events.off('routeChangeComplete', routeChangeComplete)
    }
  }, [])

  const [visited, setVisited] = useState(false)
  const config = [
    {
      id: 'list',
      icon: 'icon_usedcar',
      name: '买车',
      link: '/usedcar/x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x',
      as: '/usedcar/x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x',
      isActive: (url: string) => {
        // 选车页面
        return /\/usedcar\/(\d|has_related_video|car_source_types|x|,|-)+/g.test(
          url
        )
      },
    },
    {
      id: 'sale',
      icon: 'icon_calculate_24',
      name: '高价卖车',
      link: '/usedcar/sale',
      as: '/usedcar/sale',
      isActive: (url: string) => {
        return /\/usedcar\/sale/g.test(url)
      },
    },
  ]

  useEffect(() => {
    if (show && !visited) {
      setVisited(true)
    }
  }, [show, visited])
  return (
    <>
      <div
        className={classNames(
          styles['car-modal-mask'],
          'tw-hidden 2xl:tw-block'
        )}
      />
      <div
        className={classNames(getClassName, {
          'side-hover-item': true,
          active: show,
        })}
      >
        <ul className="side-child-wrap">
          {config.map((child: IConfig, i: number) => (
            <li key={`side-child-${i}`}>
              <Link href={child.link || ''} as={child?.as} prefetch={false}>
                <a
                  className={classNames('side-item', {
                    active: child?.isActive?.(url),
                  })}
                  target={linkTaget}
                  onClick={(e) => {
                    e.stopPropagation()
                    sendTeaCommEvent('clk_event', {
                      button_name: child.name,
                      event_id: 'common_menu_item',
                      page_id: 'page_used_car_source_list',
                    })
                  }}
                >
                  <span className={`icon lg:tw-inline-block tw-hidden`} />
                  <span className="name">{child.name}</span>
                </a>
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <style jsx>
        {`
          .side-child-wrap {
            width: 112px;
            background: #fff;
            border-radius: 2px;
          }
          .side-item {
            display: block;
            line-height: 42px;
            font-size: 14px;
            color: #1f2129;
            text-align: center;
            cursor: pointer;
          }

          .side-item:hover {
            background: rgba(255, 204, 50, 0.12);
            color: #e65800;
            cursor: pointer;
          }

          .side-item.active {
            font-weight: 500;
            color: #1f2129;
            background: linear-gradient(250deg, #ffd861 -0.65%, #ffcc32 100%);
          }
          .side-hover-item {
            transform: translate3d(-110%, 0, 0);
          }
          .side-hover-item.active {
            transform: translate3d(0, 0, 0);
          }
          .side-hover-item:hover {
            transform: translate3d(0, 0, 0);
          }
          .side-hover-item {
            z-index: 9;
            position: absolute;
            border-top: 2px solid transparent;
            border-left: 2px solid transparent;
            top: ${wrapTop}px;
            transition: transform 0.3s ease-in-out;
          }

          .on.side-hover-item {
            left: 160px !important;
            display: none;
          }

          .off.side-hover-item {
            left: 82px !important;
            display: block;
          }
        `}
      </style>
    </>
  )
}
